import React, { Component } from "react";
import { Button } from "antd-mobile";
import result_success from "../../../public/result_success.png";
import result_fail from "../../../public/result_fail.png";

import { getPathParams } from "../../../utils/utils";
import styles from './index.less';

export default class Results extends Component {
  state = {
    id: "",
    sourceEnv: null,
  };
  componentDidMount() {
    const obj = getPathParams(this.props.location.search);
    this.setState({
      id: obj.id
    });
    if (window.__wxjs_environment === 'miniprogram') {
      this.setState({
        sourceEnv: 'miniprogram',
      });
    }
  }

  backClick = () => {
    const { sourceEnv } = this.state;
    if (sourceEnv === 'miniprogram') {
      window.wx.miniProgram.navigateBack();
    }
  }

  render() {
    const { id, sourceEnv } = this.state;
    return (
      <div className={styles.bgView}>
        <div className={styles.content}>
          <img className={styles.img} src={id === '1' ? result_success : result_fail} alt="" />
          <span className={styles.text}>{id === '1' ? '协议已签订成功' : '协议签订失败'}</span>
        </div>
        {sourceEnv === 'miniprogram' ? <Button
          type="primary"
          className={styles.btn}
          onClick={this.backClick}
        >
          返回
        </Button> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/author/result/index.js